"use strict";
/*
 * Created on 07 05 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var SelloutIdentificationOverview_1 = require("../model/sellout-identification/SelloutIdentificationOverview");

var SelloutIdentificationOverviewConverter_1 = require("./SelloutIdentificationOverviewConverter");

var SelloutTypeWithItemCountsConverter_1 = require("./SelloutTypeWithItemCountsConverter");
/**
 * Implementation of {@link SelloutIdentificationOverviewConverter}.
 *
 * @author JMe
 */


var SelloutIdentificationOverviewConverterImpl =
/*#__PURE__*/
function (_SelloutIdentificatio) {
  _inherits(SelloutIdentificationOverviewConverterImpl, _SelloutIdentificatio);

  function SelloutIdentificationOverviewConverterImpl(selloutTypeWithItemCountsConverter) {
    var _this;

    _classCallCheck(this, SelloutIdentificationOverviewConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutIdentificationOverviewConverterImpl).call(this));
    _this.selloutTypeWithItemCountsConverter = selloutTypeWithItemCountsConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutIdentificationOverviewConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        categoryId: conversions.toDocumentReferenceId(source.categoryId),
        dataPerCategory: conversions.asObjectArray(source, 'dataPerCategory', function (obj) {
          return _this2.selloutTypeWithItemCountsConverter.toDocument(obj, conversions);
        })
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this3 = this;

      return new SelloutIdentificationOverview_1.SelloutIdentificationOverview(conversions.documentToClassId(source), conversions.asObject(source, 'categoryId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectList(source, 'dataPerCategory', function (doc) {
        return _this3.selloutTypeWithItemCountsConverter.toObject(doc, conversions);
      }));
    }
  }]);

  return SelloutIdentificationOverviewConverterImpl;
}(SelloutIdentificationOverviewConverter_1.SelloutIdentificationOverviewConverter);

SelloutIdentificationOverviewConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SelloutTypeWithItemCountsConverter_1.SelloutTypeWithItemCountsConverter])], SelloutIdentificationOverviewConverterImpl);
exports.SelloutIdentificationOverviewConverterImpl = SelloutIdentificationOverviewConverterImpl;